import React from 'react'
import { useTranslation } from 'react-i18next';
import { GrFormClose } from "react-icons/gr";

import { useConfig } from '../../../contexts/ConfigContext';
import { useProduct } from '../../../contexts/ProductContext';
import { useCart } from '../../../contexts/CartContext';
import { useOrder } from '../../../contexts/OrderContext';

import {
  PartTitle
} from '../styles'

import {
  CartDetailContainer,
  CartContainer,
  ProdItem,
  ProdTitleAndCount,
  ProdTitle,
  ProdCount,
  ProdImg
} from './styles'

export const CartDetail = () => {
  const currentLng = localStorage.getItem('i18nextLng');
  const [configState] = useConfig()
  const { t } = useTranslation();
  const [products] = useProduct();
  const [cart] = useCart();
  const [orderDetail] = useOrder();
  const displayCart = orderDetail?.orderCart?.length ? orderDetail.orderCart : cart;

  return (
    <CartDetailContainer>
      <PartTitle>
        {t('Order details')}
      </PartTitle>

      <CartContainer>
        {displayCart.map(item => {
          const prod = products.find(obj => obj.id === item.prodId);
          const itemName = currentLng === 'en'
            ? (item.name_en || prod?.name_en)
            : (item.name_ar || prod?.name_ar)
          const itemPrice = item.price ?? prod?.price
          return (
            <ProdItem key={item.cartId || item.prodId}>
              <div>
                <ProdTitleAndCount>
                  <ProdTitle>{itemName}</ProdTitle>
                  <ProdCount>{`${itemPrice} ${t(configState?.configs?.currency)}`}<GrFormClose size={18} /> {item.count} = {itemPrice * item.count} {t(configState?.configs?.currency)}</ProdCount>
                </ProdTitleAndCount>
              </div>
              <ProdImg src={item.image || prod?.image} />
            </ProdItem>
          )
        })}
      </CartContainer>
    </CartDetailContainer>
  )
}